Groupon.verifyUserCookies = function() {
  return setTimeout((function() {
    var el, ref, src;
    if (!(src = Groupon.endpoints.verifyCookies)) {
      return;
    }
    if ((ref = window.sessionStorage) != null ? ref.getItem('verifiedCookies') : void 0) {
      return;
    }
    el = document.createElement('script');
    el.id = 'verify_cookies';
    el.async = true;
    document.body.appendChild(el).src = src;
    try {
      return typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.setItem('verifiedCookies', true) : void 0;
    } catch (error) {}
  }), 0);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvdmVyaWZ5VXNlckNvb2tpZXMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvdmVyaWZ5VXNlckNvb2tpZXMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sQ0FBQyxpQkFBUixHQUE0QixTQUFBO1NBQzFCLFVBQUEsQ0FBVyxDQUFDLFNBQUE7QUFDVixRQUFBO0lBQUEsSUFBQSxDQUFjLENBQUEsR0FBQSxHQUFNLE9BQU8sQ0FBQyxTQUFTLENBQUMsYUFBeEIsQ0FBZDtBQUFBLGFBQUE7O0lBRUEsK0NBQStCLENBQUUsT0FBdkIsQ0FBK0IsaUJBQS9CLFVBQVY7QUFBQSxhQUFBOztJQUNBLEVBQUEsR0FBSyxRQUFRLENBQUMsYUFBVCxDQUF1QixRQUF2QjtJQUNMLEVBQUUsQ0FBQyxFQUFILEdBQVE7SUFDUixFQUFFLENBQUMsS0FBSCxHQUFXO0lBQ1gsUUFBUSxDQUFDLElBQUksQ0FBQyxXQUFkLENBQTBCLEVBQTFCLENBQTZCLENBQUMsR0FBOUIsR0FBb0M7QUFDcEM7Z0ZBQ0UsY0FBYyxDQUFFLE9BQWhCLENBQXdCLGlCQUF4QixFQUEyQyxJQUEzQyxXQURGO0tBQUE7RUFSVSxDQUFELENBQVgsRUFVQyxDQVZEO0FBRDBCIn0=
